<ion-item (click)="trocar()">
  <ion-label>Métodos de Amostragem</ion-label>
  <ion-icon color="success" size="large" slot="end" name="add-circle" (click)="add()"/>
  <ion-icon [name]="icone" size="small" slot="end"/>
</ion-item>
<ion-list *ngIf="exibir">
  <ion-item-sliding *ngFor="let met of entidades">
    <ion-item (click)="edit(met)" button detail="true">
      <ion-icon/>
      <ion-label><h3>{{ met.nome }}</h3></ion-label>
    </ion-item>
    <ion-item-options>
      <ion-item-option>
        <ion-icon (click)="edit (met)" slot="icon-only" name="pencil-outline"></ion-icon>
      </ion-item-option>
      <ion-item-option color="danger">
        <ion-icon (click)="delete(met)" slot="icon-only" name="trash"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ion-item-sliding>

</ion-list>


<ion-modal [isOpen]="isOpen">
  <form #form="ngForm">
    <ng-template>
      <ion-header>
        <ion-toolbar color="success">
          <ion-buttons slot="start">
            <ion-button (click)="close()">
              <ion-icon name="arrow-back-outline"/>
            </ion-button>
          </ion-buttons>
          <ion-title>Metodologia</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="save()">
              <ion-icon name="checkmark"/>
            </ion-button>
            <ion-button *ngIf="!novo" (click)="deleteSelected()" color="danger">
              <ion-icon name="trash"/>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-item>
          <ion-input required name="metodo" [(ngModel)]="item.nome" label="Nome do Método" labelPlacement="floating"/>
        </ion-item>
        <ion-item>
          <ion-select required="true" interface="popover" name="grupos" label-placement="floating" label="Grupos"
                      [(ngModel)]="item.grupos"
                      aria-label="Grupo"
                      [multiple]="true">
            <ion-select-option *ngFor="let fu of grupos" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-select interface="popover" name="atributosMonitoramento" label-placement="floating"
                      label="Atributos do Monitoramento"
                      [(ngModel)]="item.listaAtributos" [multiple]="true">
            <ion-select-option *ngFor="let fu of opcoesAtributos" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-select interface="popover" name="atributosEspecime" label-placement="floating"
                      label="Atributos do Espécime"
                      [(ngModel)]="item.listaAtributosEspecime" [multiple]="true">
            <ion-select-option *ngFor="let fu of atributosEspecime" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-textarea name="descricao" label="Observações" label-placement="floating" [(ngModel)]="item.obs"/>
        </ion-item>
      </ion-content>
    </ng-template>
  </form>
</ion-modal>
